import { uploadImageBlob } from '@src/slide/infrastructure/module/dependent/image/image-toolkit/cgi-upload';
import { VIDEO_DEFAULT_IMG } from '@src/slide/domain/ui-model/element-modeles/property/attachment/constants';
import { getWcjsVideoImage } from '@src/js/common/ark-extensions/dc-components/wcjs-video-player';
import { ENABLE_WCJS_VIDEO_PLAYER_RENDERER } from '@src/slide/infrastructure/module/dependent/config/renderer/switch';

const MAX_VIDEO_WIDTH = 710;
const MAX_VIDEO_HEIGHT = 710;
const DEFAULT_VIDEO_WIDTH = 710;
const DEFAULT_VIDEO_HEIGHT = 400;

export default class MediaUtils {
    public static VideoImageMap = new Map<string, string>();
    public static VideoSizeMap = new Map<string, { width: number; height: number }>();

    /**
     * 设置视频封面和宽高
     * 预加载视频实现
     * @param videoUrl 视频url
     * @returns {Promise<void>}
     */
    public static async setVideoImageAndSize(videoUrl: string): Promise<void> {
        if (!ENABLE_WCJS_VIDEO_PLAYER_RENDERER) {
            this.VideoImageMap.set(videoUrl, VIDEO_DEFAULT_IMG);
            this.VideoSizeMap.set(videoUrl, { width: DEFAULT_VIDEO_WIDTH, height: DEFAULT_VIDEO_HEIGHT });
            return Promise.resolve();
        }
        const imageBlob = await getWcjsVideoImage(videoUrl);
        return new Promise((resolve, reject) => {
            uploadImageBlob({ blob: imageBlob })
                .then(({ url: imageUrl }) => {
                    // 设置封面
                    this.VideoImageMap.set(videoUrl, imageUrl);
                    // 设置宽高
                    const image = new Image();
                    image.onload = () => {
                        this.setVideoSizeByLimit(videoUrl, image.width, image.height);
                        resolve();
                    };
                    image.src = imageUrl;
                })
                .catch(() => {
                    reject('upload file error');
                });
        });
    }

    /**
     * 等比例缩放后设置视频元素宽高
     * @param url 视频 url
     * @param width 视频原始宽
     * @param height 视频原始高
     * @returns void
     */
    private static setVideoSizeByLimit(url: string, width: number, height: number) {
        if (width <= MAX_VIDEO_WIDTH && height <= MAX_VIDEO_HEIGHT) {
            const size = { width, height };
            this.VideoSizeMap.set(url, size);
            return;
        }
        // 按最大宽度等比例缩放
        if (width / height > MAX_VIDEO_WIDTH / MAX_VIDEO_HEIGHT) {
            const size = { width: MAX_VIDEO_WIDTH, height: Math.floor((MAX_VIDEO_WIDTH / width) * height) };
            this.VideoSizeMap.set(url, size);
            return;
        }
        // 按最大高度等比例缩放
        const size = { width: Math.floor((MAX_VIDEO_HEIGHT / height) * width), height: MAX_VIDEO_HEIGHT };
        this.VideoSizeMap.set(url, size);
    }
}
